/**
 * Filter bar — desktop quick-access buttons.
 *
 * When a specific filter button is clicked: open the drawer, close all
 * filter accordions, then open + scroll to the matching one.
 *
 * When "All filters" is clicked: open the drawer, close all filter
 * accordions, then open the first one.
 */

const ALL = '__all';
/** @type {string | null} */
let pendingTarget = null;

document.addEventListener('click', (e) => {
  const el = /** @type {Element} */ (e.target);
  const filterBtn = el.closest('[data-filter-target]');
  if (filterBtn instanceof HTMLElement) {
    pendingTarget = filterBtn.dataset.filterTarget ?? null;
    return;
  }
  if (el.closest('.op-filter-bar__btn--all')) {
    pendingTarget = ALL;
  }
});

const drawer = document.getElementById('filters-drawer');
if (drawer) {
  const dialog = drawer.querySelector('dialog');
  if (dialog) {
    new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.attributeName !== 'open') continue;
        if (!dialog.hasAttribute('open') || !pendingTarget) continue;

        const target = pendingTarget;
        pendingTarget = null;

        requestAnimationFrame(() => {
          // Close all accordion-custom elements and their inner details
          drawer.querySelectorAll('accordion-custom').forEach((ac) => {
            ac.removeAttribute('open');
            const d = ac.querySelector('details');
            if (d instanceof HTMLDetailsElement) d.open = false;
          });

          /** @param {Element} ac */
          function openAccordion(ac) {
            ac.setAttribute('open', '');
            const d = ac.querySelector('details');
            if (d instanceof HTMLDetailsElement) d.open = true;
            ac.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }

          if (target === ALL) {
            const first = drawer.querySelector('accordion-custom');
            if (first) openAccordion(first);
          } else {
            const accordion = drawer.querySelector(`accordion-custom[data-filter-param-name="${target}"]`);
            if (accordion) openAccordion(accordion);
          }
        });
      }
    }).observe(dialog, { attributes: true });
  }
}
